export default __webpack_public_path__ + "static/media/decision_finished_competent.bea09a5c.png";